export function marquee() {
  const marquees = document.querySelectorAll('.js-marquee');
  if (!marquees.length) return;

  marquees.forEach((marquee) => {
    // 対象コンテナ・コンテンツの存在チェック（早期リターン）
    const marqueeContainer = marquee.querySelector('.marquee-container');
    const marqueeContent = marquee.querySelector('.marquee-content');
    if (!marqueeContainer || !marqueeContent) return;

    const marqueeElements = marqueeContent.querySelectorAll('.marquee-element');
    if (!marqueeElements.length) return;

    // コンテナの横幅取得し、スクロール領域が2倍未満ならクローンを追加
    let containerWidth = marquee.offsetWidth;

    // まず最初のクローンを作成（シームレスな継ぎ目のため）
    const firstClone = marqueeContent.cloneNode(true);
    marqueeContainer.appendChild(firstClone);

    const ensureClones = () => {
      containerWidth = marquee.offsetWidth;
      if (!containerWidth || !marqueeContent.offsetWidth) return;

      // 必要に応じて追加のクローンを作成
      while (marqueeContainer.scrollWidth < containerWidth * 2) {
        marqueeContainer.appendChild(marqueeContent.cloneNode(true));
      }
    };

    ensureClones();

    // data属性からパラメータを読み込み
    const speed = Number(marquee.dataset.speed) || 1;
    const direction = marquee.dataset.direction === 'right' ? 1 : -1;
    const pauseOnHover = marquee.dataset.pause === 'true';

    let pause = false;
    let currentPosition = 0;

    // 一つのコンテンツブロックの幅を計算（ループの基準点）
    let contentBlockWidth = marqueeContent.offsetWidth;
    let totalScrollWidth = marqueeContainer.scrollWidth;

    // CSS transform用の関数
    const setTransform = (position) => {
      marqueeContainer.style.transform = `translate3d(${position}px, 0, 0)`;
    };

    // ループ位置更新：iOS Safariでのガタつき防止のため改良
    const updatePosition = () => {
      currentPosition += speed * direction;

      // 右方向スクロールの場合
      if (direction > 0) {
        // contentBlockWidthに達したらリセット
        if (currentPosition >= contentBlockWidth) {
          currentPosition = 0;
        }
      }
      // 左方向スクロールの場合
      else {
        // -contentBlockWidthに達したらリセット
        if (Math.abs(currentPosition) >= contentBlockWidth) {
          currentPosition = 0;
        }
      }

      setTransform(currentPosition);
    };

    const animate = () => {
      if (!pause) updatePosition();
      requestAnimationFrame(animate);
    };

    // マウスホバーで一時停止（必要な場合）
    if (pauseOnHover) {
      marquee.addEventListener('mouseover', () => (pause = true));
      marquee.addEventListener('mouseout', () => (pause = false));
    }

    const refreshMetrics = () => {
      ensureClones();
      totalScrollWidth = marqueeContainer.scrollWidth;
      const updatedContentWidth = marqueeContent.offsetWidth;

      if (updatedContentWidth && updatedContentWidth !== contentBlockWidth) {
        contentBlockWidth = updatedContentWidth;
        currentPosition = 0;
        setTransform(currentPosition);
      }
    };

    // リサイズ時のスクロール幅更新処理
    if ('ResizeObserver' in window) {
      // ResizeObserver に対応している場合は、marqueeContainer のサイズ変化を監視
      const resizeObserver = new ResizeObserver(refreshMetrics);
      resizeObserver.observe(marqueeContainer);
    } else {
      // ResizeObserver 未対応の場合は、window の resize イベントと setInterval で更新
      let lastWindowWidth = window.innerWidth;
      window.addEventListener('resize', () => {
        if (lastWindowWidth !== window.innerWidth) {
          lastWindowWidth = window.innerWidth;
          refreshMetrics();
        }
      });
      setInterval(() => {
        refreshMetrics();
      }, 1000);
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refreshMetrics);
    }

    // 初期位置を設定
    setTransform(currentPosition);

    // アニメーション開始
    animate();

    marquee.classList.add('is-active');
  });
}
